import axios from "axios";
import Cookie from "cookie-universal";

export const cookie = Cookie();
export const Axios = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_URL,
});
export const authAxios = axios.create({
  baseURL: process.env.REACT_APP_PUBLIC_URL,
});

authAxios.interceptors.request.use(
  (config) => {
    const token = cookie.get("bearer");

    if (token) {
      config.headers.Authorization = `bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
    console.log(error);
  }
);
